export default template;
function pug_attr(t,e,n,r){if(!1===e||null==e||!e&&("class"===t||"style"===t))return"";if(!0===e)return" "+(r?t:t+'="'+t+'"');var f=typeof e;return"object"!==f&&"function"!==f||"function"!=typeof e.toJSON||(e=e.toJSON()),"string"==typeof e||(e=JSON.stringify(e),n||-1===e.indexOf('"'))?(n&&(e=pug_escape(e))," "+t+'="'+e+'"'):" "+t+"='"+e.replace(/'/g,"&#39;")+"'"}
function pug_classes(s,r){return Array.isArray(s)?pug_classes_array(s,r):s&&"object"==typeof s?pug_classes_object(s):s||""}
function pug_classes_array(r,a){for(var s,e="",u="",c=Array.isArray(a),g=0;g<r.length;g++)(s=pug_classes(r[g]))&&(c&&a[g]&&(s=pug_escape(s)),e=e+u+s,u=" ");return e}
function pug_classes_object(r){var a="",n="";for(var o in r)o&&r[o]&&pug_has_own_property.call(r,o)&&(a=a+n+o,n=" ");return a}
function pug_escape(e){var a=""+e,t=pug_match_html.exec(a);if(!t)return e;var r,c,n,s="";for(r=t.index,c=0;r<a.length;r++){switch(a.charCodeAt(r)){case 34:n="&quot;";break;case 38:n="&amp;";break;case 60:n="&lt;";break;case 62:n="&gt;";break;default:continue}c!==r&&(s+=a.substring(c,r)),c=r+1,s+=n}return c!==r?s+a.substring(c,r):s}
var pug_has_own_property=Object.prototype.hasOwnProperty;
var pug_match_html=/["&<>]/;function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (countLabels, customFieldsSorter, getDeliveryCost, getOrderTimeInfo, highlightOption, isToPay, labelDate, orders, prettyOption, print_format, renderDollars, renderName, toQRCodeUrl) {
      pug_mixins["render_address"] = pug_interp = function(address, order, suppressName, directionsUrl){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv class=\"address\"\u003E";
if (directionsUrl) {
pug_html = pug_html + "\u003Ca" + (" class=\"directions\""+" target=\"_blank\""+pug_attr("href", directionsUrl, true, true)) + "\u003E\u003Cimg src=\"images\u002Fnavigation.png\"\u003E\u003C\u002Fa\u003E";
}
if (! suppressName) {
pug_html = pug_html + "\u003Cdiv class=\"name\"\u003E" + (pug_escape(null == (pug_interp = address.fullName && address.fullName.firstName) ? "" : pug_interp)) + " " + (pug_escape(null == (pug_interp = address.fullName && address.fullName.lastName) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
if (address.company) {
pug_html = pug_html + "\u003Cdiv class=\"company\"\u003E" + (pug_escape(null == (pug_interp = address.company) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003Cdiv class=\"line\"\u003E";
if (address.street) {
pug_html = pug_html + ((pug_escape(null == (pug_interp = address.street.number) ? "" : pug_interp)) + " " + (pug_escape(null == (pug_interp = address.street.name) ? "" : pug_interp)));
}
else {
pug_html = pug_html + (pug_escape(null == (pug_interp = address.addressLine1) ? "" : pug_interp));
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
if (address.addressLine2) {
pug_html = pug_html + "\u003Cdiv class=\"line\"\u003E" + (pug_escape(null == (pug_interp = address.addressLine2) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
if (order && order.customField && order.customField.title == "Apartment Number, suite, etc") {
pug_html = pug_html + "\u003Cdiv class=\"line\"\u003E" + (pug_escape(null == (pug_interp = order.customField.value) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003Cdiv class=\"city\"\u003E" + (pug_escape(null == (pug_interp = address.city) ? "" : pug_interp)) + " " + (pug_escape(null == (pug_interp = address.zipCode) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
if (! suppressName) {
pug_html = pug_html + "\u003Cdiv class=\"phone\"\u003E" + (pug_escape(null == (pug_interp = address.phone) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
if (address.business) {
pug_html = pug_html + "\u003Cdiv class=\"line\"\u003E\u003Cstrong\u003E(Business)\u003C\u002Fstrong\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
pug_html = pug_html + "\u003Cdiv class=\"function-body\"\u003E";
if (orders.length > 0) {
pug_html = pug_html + "\u003Cdiv class=\"print-orders\"\u003E\u003Cdiv class=\"controls noprint\"\u003E\u003Cbutton class=\"write-cards\"\u003E\u003Ci class=\"fa-solid fa-print\"\u003E\u003C\u002Fi\u003E\n\nWrite cards\u003C\u002Fbutton\u003E\u003Cbutton class=\"select-print-format\" data-format=\"paper\"\u003E\u003Ci class=\"fa-solid fa-print\"\u003E\u003C\u002Fi\u003E\n\nPaper\u003C\u002Fbutton\u003E\u003Cbutton class=\"select-print-format\" data-format=\"label\"\u003E\u003Ci class=\"fa-solid fa-print\"\u003E\u003C\u002Fi\u003E\n\nLabels\u003C\u002Fbutton\u003E\u003Cbutton class=\"mark-as-printed\"\u003EUpdate status to Printed on " + (pug_escape(null == (pug_interp = orders.length) ? "" : pug_interp)) + " " + (pug_escape(null == (pug_interp = orders.length == 1 ? "order" : "orders") ? "" : pug_interp)) + "\u003C\u002Fbutton\u003E\u003Chr\u003E\u003C!-- a(href=`api\u002Forders\u002Fprint\u002F${order_ids}`) Labels PDF--\u003E\u003C\u002Fdiv\u003E";
if (print_format == "paper") {
pug_html = pug_html + "\u003Cdiv class=\"print-format paper\"\u003E";
// iterate orders
;(function(){
  var $$obj = orders;
  if ('number' == typeof $$obj.length) {
      for (var idx = 0, $$l = $$obj.length; idx < $$l; idx++) {
        var order = $$obj[idx];
pug_html = pug_html + "\u003Cdiv class=\"order-container\"\u003E\u003Cdiv class=\"order\"\u003E\u003Cdiv class=\"header\"\u003E\u003Cdiv\u003EOrder " + (pug_escape(null == (pug_interp = order.number) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"qrcode-container\"\u003E\u003Cdiv\u003E\u003Ccanvas" + (" class=\"qrcode\""+pug_attr("data-url", toQRCodeUrl(order.qrcode_id), true, true)) + "\u003E\u003C\u002Fcanvas\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"buyerInfo\"\u003E\u003Cdiv class=\"name\"\u003E" + (pug_escape(null == (pug_interp = order.buyerInfo.firstName) ? "" : pug_interp)) + " " + (pug_escape(null == (pug_interp = order.buyerInfo.lastName) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"email\"\u003E" + (pug_escape(null == (pug_interp = order.buyerInfo.email) ? "" : pug_interp)) + "\n\n\n" + (pug_escape(null == (pug_interp = order.buyerInfo.phone) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
if (order.shippingInfo && order.shippingInfo.shipmentDetails && order.shippingInfo.shipmentDetails.address) {
pug_html = pug_html + "\u003Cdiv class=\"shipping-address\"\u003E\u003Cb\u003EDelivery address\u003C\u002Fb\u003E";
pug_mixins["render_address"](order.shippingInfo.shipmentDetails.address, order);
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
}
if (isToPay(order)) {
pug_html = pug_html + "\u003Cdiv\u003E\u003Cstrong style=\"margin-top: 1em\"\u003ETO PAY\u003C\u002Fstrong\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"lineItems\"\u003E";
// iterate order.lineItems
;(function(){
  var $$obj = order.lineItems;
  if ('number' == typeof $$obj.length) {
      for (var pug_index1 = 0, $$l = $$obj.length; pug_index1 < $$l; pug_index1++) {
        var lineItem = $$obj[pug_index1];
pug_html = pug_html + ("\u003Cdiv class=\"lineItem\"\u003E\u003Cdiv class=\"name\"\u003E" + (pug_escape(null == (pug_interp = renderName(lineItem)) ? "" : pug_interp)));
if (lineItem.quantity > 1) {
pug_html = pug_html + "\n\u003Cstrong\u003EQuantity: " + (pug_escape(null == (pug_interp = lineItem.quantity) ? "" : pug_interp)) + "\u003C\u002Fstrong\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"options\"\u003E";
// iterate (lineItem.options || [])
;(function(){
  var $$obj = (lineItem.options || []);
  if ('number' == typeof $$obj.length) {
      for (var pug_index2 = 0, $$l = $$obj.length; pug_index2 < $$l; pug_index2++) {
        var option = $$obj[pug_index2];
if (option.selection != "No") {
pug_html = pug_html + "\u003Cdiv class=\"option\"\u003E" + (pug_escape(null == (pug_interp = option.option) ? "" : pug_interp)) + " : " + (pug_escape(null == (pug_interp = option.selection) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
      }
  } else {
    var $$l = 0;
    for (var pug_index2 in $$obj) {
      $$l++;
      var option = $$obj[pug_index2];
if (option.selection != "No") {
pug_html = pug_html + "\u003Cdiv class=\"option\"\u003E" + (pug_escape(null == (pug_interp = option.option) ? "" : pug_interp)) + " : " + (pug_escape(null == (pug_interp = option.selection) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
    }
  }
}).call(this);

var deliveryCost = getDeliveryCost(order);
if (deliveryCost) {
pug_html = pug_html + "\u003Cdiv class=\"option\"\u003EDelivery cost: " + (pug_escape(null == (pug_interp = renderDollars(deliveryCost)) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
var customTextFields = customFieldsSorter(lineItem.customTextFields || [])
var done = {};
pug_html = pug_html + "\u003Cdiv class=\"noteToFlorist\"\u003E";
// iterate customTextFields.filter((f) => f.title.toLowerCase().startsWith("note to florist") && f.value)
;(function(){
  var $$obj = customTextFields.filter((f) => f.title.toLowerCase().startsWith("note to florist") && f.value);
  if ('number' == typeof $$obj.length) {
      for (var pug_index3 = 0, $$l = $$obj.length; pug_index3 < $$l; pug_index3++) {
        var customTextField = $$obj[pug_index3];
done[customTextField.title] = 1;
pug_html = pug_html + "\u003Cdiv class=\"customTextField\"\u003E\u003Cdiv class=\"title\"\u003E" + (pug_escape(null == (pug_interp = customTextField.title) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"value\"\u003E" + (pug_escape(null == (pug_interp = customTextField.value) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index3 in $$obj) {
      $$l++;
      var customTextField = $$obj[pug_index3];
done[customTextField.title] = 1;
pug_html = pug_html + "\u003Cdiv class=\"customTextField\"\u003E\u003Cdiv class=\"title\"\u003E" + (pug_escape(null == (pug_interp = customTextField.title) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"value\"\u003E" + (pug_escape(null == (pug_interp = customTextField.value) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

if (order.buyerNote) {
pug_html = pug_html + "\u003Cdiv class=\"customTextField\"\u003E\u003Cdiv class=\"title\"\u003EBuyer note:\u003C\u002Fdiv\u003E\u003Cdiv class=\"value\"\u003E" + (pug_escape(null == (pug_interp = order.buyerNote) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"customTextFields\"\u003E";
// iterate customTextFields.filter((f) => ! done[f.title] && f.value)
;(function(){
  var $$obj = customTextFields.filter((f) => ! done[f.title] && f.value);
  if ('number' == typeof $$obj.length) {
      for (var pug_index4 = 0, $$l = $$obj.length; pug_index4 < $$l; pug_index4++) {
        var customTextField = $$obj[pug_index4];
pug_html = pug_html + "\u003Cdiv class=\"customTextField\"\u003E\u003Cdiv class=\"title\"\u003E" + (pug_escape(null == (pug_interp = customTextField.title) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003Cdiv" + (pug_attr("class", pug_classes(["value",{highlight: customTextField.title.toLowerCase().indexOf("delivery date") >= 0}], [false,true]), false, true)) + "\u003E" + (pug_escape(null == (pug_interp = customTextField.value) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index4 in $$obj) {
      $$l++;
      var customTextField = $$obj[pug_index4];
pug_html = pug_html + "\u003Cdiv class=\"customTextField\"\u003E\u003Cdiv class=\"title\"\u003E" + (pug_escape(null == (pug_interp = customTextField.title) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003Cdiv" + (pug_attr("class", pug_classes(["value",{highlight: customTextField.title.toLowerCase().indexOf("delivery date") >= 0}], [false,true]), false, true)) + "\u003E" + (pug_escape(null == (pug_interp = customTextField.value) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index1 in $$obj) {
      $$l++;
      var lineItem = $$obj[pug_index1];
pug_html = pug_html + ("\u003Cdiv class=\"lineItem\"\u003E\u003Cdiv class=\"name\"\u003E" + (pug_escape(null == (pug_interp = renderName(lineItem)) ? "" : pug_interp)));
if (lineItem.quantity > 1) {
pug_html = pug_html + "\n\u003Cstrong\u003EQuantity: " + (pug_escape(null == (pug_interp = lineItem.quantity) ? "" : pug_interp)) + "\u003C\u002Fstrong\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"options\"\u003E";
// iterate (lineItem.options || [])
;(function(){
  var $$obj = (lineItem.options || []);
  if ('number' == typeof $$obj.length) {
      for (var pug_index5 = 0, $$l = $$obj.length; pug_index5 < $$l; pug_index5++) {
        var option = $$obj[pug_index5];
if (option.selection != "No") {
pug_html = pug_html + "\u003Cdiv class=\"option\"\u003E" + (pug_escape(null == (pug_interp = option.option) ? "" : pug_interp)) + " : " + (pug_escape(null == (pug_interp = option.selection) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
      }
  } else {
    var $$l = 0;
    for (var pug_index5 in $$obj) {
      $$l++;
      var option = $$obj[pug_index5];
if (option.selection != "No") {
pug_html = pug_html + "\u003Cdiv class=\"option\"\u003E" + (pug_escape(null == (pug_interp = option.option) ? "" : pug_interp)) + " : " + (pug_escape(null == (pug_interp = option.selection) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
    }
  }
}).call(this);

var deliveryCost = getDeliveryCost(order);
if (deliveryCost) {
pug_html = pug_html + "\u003Cdiv class=\"option\"\u003EDelivery cost: " + (pug_escape(null == (pug_interp = renderDollars(deliveryCost)) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
var customTextFields = customFieldsSorter(lineItem.customTextFields || [])
var done = {};
pug_html = pug_html + "\u003Cdiv class=\"noteToFlorist\"\u003E";
// iterate customTextFields.filter((f) => f.title.toLowerCase().startsWith("note to florist") && f.value)
;(function(){
  var $$obj = customTextFields.filter((f) => f.title.toLowerCase().startsWith("note to florist") && f.value);
  if ('number' == typeof $$obj.length) {
      for (var pug_index6 = 0, $$l = $$obj.length; pug_index6 < $$l; pug_index6++) {
        var customTextField = $$obj[pug_index6];
done[customTextField.title] = 1;
pug_html = pug_html + "\u003Cdiv class=\"customTextField\"\u003E\u003Cdiv class=\"title\"\u003E" + (pug_escape(null == (pug_interp = customTextField.title) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"value\"\u003E" + (pug_escape(null == (pug_interp = customTextField.value) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index6 in $$obj) {
      $$l++;
      var customTextField = $$obj[pug_index6];
done[customTextField.title] = 1;
pug_html = pug_html + "\u003Cdiv class=\"customTextField\"\u003E\u003Cdiv class=\"title\"\u003E" + (pug_escape(null == (pug_interp = customTextField.title) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"value\"\u003E" + (pug_escape(null == (pug_interp = customTextField.value) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

if (order.buyerNote) {
pug_html = pug_html + "\u003Cdiv class=\"customTextField\"\u003E\u003Cdiv class=\"title\"\u003EBuyer note:\u003C\u002Fdiv\u003E\u003Cdiv class=\"value\"\u003E" + (pug_escape(null == (pug_interp = order.buyerNote) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"customTextFields\"\u003E";
// iterate customTextFields.filter((f) => ! done[f.title] && f.value)
;(function(){
  var $$obj = customTextFields.filter((f) => ! done[f.title] && f.value);
  if ('number' == typeof $$obj.length) {
      for (var pug_index7 = 0, $$l = $$obj.length; pug_index7 < $$l; pug_index7++) {
        var customTextField = $$obj[pug_index7];
pug_html = pug_html + "\u003Cdiv class=\"customTextField\"\u003E\u003Cdiv class=\"title\"\u003E" + (pug_escape(null == (pug_interp = customTextField.title) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003Cdiv" + (pug_attr("class", pug_classes(["value",{highlight: customTextField.title.toLowerCase().indexOf("delivery date") >= 0}], [false,true]), false, true)) + "\u003E" + (pug_escape(null == (pug_interp = customTextField.value) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index7 in $$obj) {
      $$l++;
      var customTextField = $$obj[pug_index7];
pug_html = pug_html + "\u003Cdiv class=\"customTextField\"\u003E\u003Cdiv class=\"title\"\u003E" + (pug_escape(null == (pug_interp = customTextField.title) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003Cdiv" + (pug_attr("class", pug_classes(["value",{highlight: customTextField.title.toLowerCase().indexOf("delivery date") >= 0}], [false,true]), false, true)) + "\u003E" + (pug_escape(null == (pug_interp = customTextField.value) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
if (order.totals && order.totals.total) {
pug_html = pug_html + "\u003Cdiv class=\"totalPrice\"\u003E\u003Cp\u003ETotal order charge\n\n\u003Cb\u003E" + (pug_escape(null == (pug_interp = renderDollars(order.totals.total)) ? "" : pug_interp)) + "\u003C\u002Fb\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
if (idx < orders.length - 1) {
pug_html = pug_html + "\u003Cdiv class=\"pagebreak\"\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var idx in $$obj) {
      $$l++;
      var order = $$obj[idx];
pug_html = pug_html + "\u003Cdiv class=\"order-container\"\u003E\u003Cdiv class=\"order\"\u003E\u003Cdiv class=\"header\"\u003E\u003Cdiv\u003EOrder " + (pug_escape(null == (pug_interp = order.number) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"qrcode-container\"\u003E\u003Cdiv\u003E\u003Ccanvas" + (" class=\"qrcode\""+pug_attr("data-url", toQRCodeUrl(order.qrcode_id), true, true)) + "\u003E\u003C\u002Fcanvas\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"buyerInfo\"\u003E\u003Cdiv class=\"name\"\u003E" + (pug_escape(null == (pug_interp = order.buyerInfo.firstName) ? "" : pug_interp)) + " " + (pug_escape(null == (pug_interp = order.buyerInfo.lastName) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"email\"\u003E" + (pug_escape(null == (pug_interp = order.buyerInfo.email) ? "" : pug_interp)) + "\n\n\n" + (pug_escape(null == (pug_interp = order.buyerInfo.phone) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
if (order.shippingInfo && order.shippingInfo.shipmentDetails && order.shippingInfo.shipmentDetails.address) {
pug_html = pug_html + "\u003Cdiv class=\"shipping-address\"\u003E\u003Cb\u003EDelivery address\u003C\u002Fb\u003E";
pug_mixins["render_address"](order.shippingInfo.shipmentDetails.address, order);
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
}
if (isToPay(order)) {
pug_html = pug_html + "\u003Cdiv\u003E\u003Cstrong style=\"margin-top: 1em\"\u003ETO PAY\u003C\u002Fstrong\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"lineItems\"\u003E";
// iterate order.lineItems
;(function(){
  var $$obj = order.lineItems;
  if ('number' == typeof $$obj.length) {
      for (var pug_index8 = 0, $$l = $$obj.length; pug_index8 < $$l; pug_index8++) {
        var lineItem = $$obj[pug_index8];
pug_html = pug_html + ("\u003Cdiv class=\"lineItem\"\u003E\u003Cdiv class=\"name\"\u003E" + (pug_escape(null == (pug_interp = renderName(lineItem)) ? "" : pug_interp)));
if (lineItem.quantity > 1) {
pug_html = pug_html + "\n\u003Cstrong\u003EQuantity: " + (pug_escape(null == (pug_interp = lineItem.quantity) ? "" : pug_interp)) + "\u003C\u002Fstrong\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"options\"\u003E";
// iterate (lineItem.options || [])
;(function(){
  var $$obj = (lineItem.options || []);
  if ('number' == typeof $$obj.length) {
      for (var pug_index9 = 0, $$l = $$obj.length; pug_index9 < $$l; pug_index9++) {
        var option = $$obj[pug_index9];
if (option.selection != "No") {
pug_html = pug_html + "\u003Cdiv class=\"option\"\u003E" + (pug_escape(null == (pug_interp = option.option) ? "" : pug_interp)) + " : " + (pug_escape(null == (pug_interp = option.selection) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
      }
  } else {
    var $$l = 0;
    for (var pug_index9 in $$obj) {
      $$l++;
      var option = $$obj[pug_index9];
if (option.selection != "No") {
pug_html = pug_html + "\u003Cdiv class=\"option\"\u003E" + (pug_escape(null == (pug_interp = option.option) ? "" : pug_interp)) + " : " + (pug_escape(null == (pug_interp = option.selection) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
    }
  }
}).call(this);

var deliveryCost = getDeliveryCost(order);
if (deliveryCost) {
pug_html = pug_html + "\u003Cdiv class=\"option\"\u003EDelivery cost: " + (pug_escape(null == (pug_interp = renderDollars(deliveryCost)) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
var customTextFields = customFieldsSorter(lineItem.customTextFields || [])
var done = {};
pug_html = pug_html + "\u003Cdiv class=\"noteToFlorist\"\u003E";
// iterate customTextFields.filter((f) => f.title.toLowerCase().startsWith("note to florist") && f.value)
;(function(){
  var $$obj = customTextFields.filter((f) => f.title.toLowerCase().startsWith("note to florist") && f.value);
  if ('number' == typeof $$obj.length) {
      for (var pug_index10 = 0, $$l = $$obj.length; pug_index10 < $$l; pug_index10++) {
        var customTextField = $$obj[pug_index10];
done[customTextField.title] = 1;
pug_html = pug_html + "\u003Cdiv class=\"customTextField\"\u003E\u003Cdiv class=\"title\"\u003E" + (pug_escape(null == (pug_interp = customTextField.title) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"value\"\u003E" + (pug_escape(null == (pug_interp = customTextField.value) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index10 in $$obj) {
      $$l++;
      var customTextField = $$obj[pug_index10];
done[customTextField.title] = 1;
pug_html = pug_html + "\u003Cdiv class=\"customTextField\"\u003E\u003Cdiv class=\"title\"\u003E" + (pug_escape(null == (pug_interp = customTextField.title) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"value\"\u003E" + (pug_escape(null == (pug_interp = customTextField.value) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

if (order.buyerNote) {
pug_html = pug_html + "\u003Cdiv class=\"customTextField\"\u003E\u003Cdiv class=\"title\"\u003EBuyer note:\u003C\u002Fdiv\u003E\u003Cdiv class=\"value\"\u003E" + (pug_escape(null == (pug_interp = order.buyerNote) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"customTextFields\"\u003E";
// iterate customTextFields.filter((f) => ! done[f.title] && f.value)
;(function(){
  var $$obj = customTextFields.filter((f) => ! done[f.title] && f.value);
  if ('number' == typeof $$obj.length) {
      for (var pug_index11 = 0, $$l = $$obj.length; pug_index11 < $$l; pug_index11++) {
        var customTextField = $$obj[pug_index11];
pug_html = pug_html + "\u003Cdiv class=\"customTextField\"\u003E\u003Cdiv class=\"title\"\u003E" + (pug_escape(null == (pug_interp = customTextField.title) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003Cdiv" + (pug_attr("class", pug_classes(["value",{highlight: customTextField.title.toLowerCase().indexOf("delivery date") >= 0}], [false,true]), false, true)) + "\u003E" + (pug_escape(null == (pug_interp = customTextField.value) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index11 in $$obj) {
      $$l++;
      var customTextField = $$obj[pug_index11];
pug_html = pug_html + "\u003Cdiv class=\"customTextField\"\u003E\u003Cdiv class=\"title\"\u003E" + (pug_escape(null == (pug_interp = customTextField.title) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003Cdiv" + (pug_attr("class", pug_classes(["value",{highlight: customTextField.title.toLowerCase().indexOf("delivery date") >= 0}], [false,true]), false, true)) + "\u003E" + (pug_escape(null == (pug_interp = customTextField.value) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index8 in $$obj) {
      $$l++;
      var lineItem = $$obj[pug_index8];
pug_html = pug_html + ("\u003Cdiv class=\"lineItem\"\u003E\u003Cdiv class=\"name\"\u003E" + (pug_escape(null == (pug_interp = renderName(lineItem)) ? "" : pug_interp)));
if (lineItem.quantity > 1) {
pug_html = pug_html + "\n\u003Cstrong\u003EQuantity: " + (pug_escape(null == (pug_interp = lineItem.quantity) ? "" : pug_interp)) + "\u003C\u002Fstrong\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"options\"\u003E";
// iterate (lineItem.options || [])
;(function(){
  var $$obj = (lineItem.options || []);
  if ('number' == typeof $$obj.length) {
      for (var pug_index12 = 0, $$l = $$obj.length; pug_index12 < $$l; pug_index12++) {
        var option = $$obj[pug_index12];
if (option.selection != "No") {
pug_html = pug_html + "\u003Cdiv class=\"option\"\u003E" + (pug_escape(null == (pug_interp = option.option) ? "" : pug_interp)) + " : " + (pug_escape(null == (pug_interp = option.selection) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
      }
  } else {
    var $$l = 0;
    for (var pug_index12 in $$obj) {
      $$l++;
      var option = $$obj[pug_index12];
if (option.selection != "No") {
pug_html = pug_html + "\u003Cdiv class=\"option\"\u003E" + (pug_escape(null == (pug_interp = option.option) ? "" : pug_interp)) + " : " + (pug_escape(null == (pug_interp = option.selection) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
    }
  }
}).call(this);

var deliveryCost = getDeliveryCost(order);
if (deliveryCost) {
pug_html = pug_html + "\u003Cdiv class=\"option\"\u003EDelivery cost: " + (pug_escape(null == (pug_interp = renderDollars(deliveryCost)) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
var customTextFields = customFieldsSorter(lineItem.customTextFields || [])
var done = {};
pug_html = pug_html + "\u003Cdiv class=\"noteToFlorist\"\u003E";
// iterate customTextFields.filter((f) => f.title.toLowerCase().startsWith("note to florist") && f.value)
;(function(){
  var $$obj = customTextFields.filter((f) => f.title.toLowerCase().startsWith("note to florist") && f.value);
  if ('number' == typeof $$obj.length) {
      for (var pug_index13 = 0, $$l = $$obj.length; pug_index13 < $$l; pug_index13++) {
        var customTextField = $$obj[pug_index13];
done[customTextField.title] = 1;
pug_html = pug_html + "\u003Cdiv class=\"customTextField\"\u003E\u003Cdiv class=\"title\"\u003E" + (pug_escape(null == (pug_interp = customTextField.title) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"value\"\u003E" + (pug_escape(null == (pug_interp = customTextField.value) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index13 in $$obj) {
      $$l++;
      var customTextField = $$obj[pug_index13];
done[customTextField.title] = 1;
pug_html = pug_html + "\u003Cdiv class=\"customTextField\"\u003E\u003Cdiv class=\"title\"\u003E" + (pug_escape(null == (pug_interp = customTextField.title) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"value\"\u003E" + (pug_escape(null == (pug_interp = customTextField.value) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

if (order.buyerNote) {
pug_html = pug_html + "\u003Cdiv class=\"customTextField\"\u003E\u003Cdiv class=\"title\"\u003EBuyer note:\u003C\u002Fdiv\u003E\u003Cdiv class=\"value\"\u003E" + (pug_escape(null == (pug_interp = order.buyerNote) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"customTextFields\"\u003E";
// iterate customTextFields.filter((f) => ! done[f.title] && f.value)
;(function(){
  var $$obj = customTextFields.filter((f) => ! done[f.title] && f.value);
  if ('number' == typeof $$obj.length) {
      for (var pug_index14 = 0, $$l = $$obj.length; pug_index14 < $$l; pug_index14++) {
        var customTextField = $$obj[pug_index14];
pug_html = pug_html + "\u003Cdiv class=\"customTextField\"\u003E\u003Cdiv class=\"title\"\u003E" + (pug_escape(null == (pug_interp = customTextField.title) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003Cdiv" + (pug_attr("class", pug_classes(["value",{highlight: customTextField.title.toLowerCase().indexOf("delivery date") >= 0}], [false,true]), false, true)) + "\u003E" + (pug_escape(null == (pug_interp = customTextField.value) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index14 in $$obj) {
      $$l++;
      var customTextField = $$obj[pug_index14];
pug_html = pug_html + "\u003Cdiv class=\"customTextField\"\u003E\u003Cdiv class=\"title\"\u003E" + (pug_escape(null == (pug_interp = customTextField.title) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003Cdiv" + (pug_attr("class", pug_classes(["value",{highlight: customTextField.title.toLowerCase().indexOf("delivery date") >= 0}], [false,true]), false, true)) + "\u003E" + (pug_escape(null == (pug_interp = customTextField.value) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
if (order.totals && order.totals.total) {
pug_html = pug_html + "\u003Cdiv class=\"totalPrice\"\u003E\u003Cp\u003ETotal order charge\n\n\u003Cb\u003E" + (pug_escape(null == (pug_interp = renderDollars(order.totals.total)) ? "" : pug_interp)) + "\u003C\u002Fb\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
if (idx < orders.length - 1) {
pug_html = pug_html + "\u003Cdiv class=\"pagebreak\"\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
}
if (print_format == "label") {
pug_html = pug_html + "\u003Cdiv class=\"print-format label\"\u003E";
// iterate orders
;(function(){
  var $$obj = orders;
  if ('number' == typeof $$obj.length) {
      for (var idx = 0, $$l = $$obj.length; idx < $$l; idx++) {
        var order = $$obj[idx];
// iterate order.lineItems
;(function(){
  var $$obj = order.lineItems;
  if ('number' == typeof $$obj.length) {
      for (var lidx = 0, $$l = $$obj.length; lidx < $$l; lidx++) {
        var lineItem = $$obj[lidx];
var shipmentDetailsAddress = order.shippingInfo && order.shippingInfo.shipmentDetails && order.shippingInfo.shipmentDetails.address;
var labelCount = countLabels(lineItem)
for (let i = 0; i < labelCount; i++)
{
pug_html = pug_html + "\u003Cdiv class=\"order-container\"\u003E\u003Cdiv class=\"order\"\u003E\u003Cdiv class=\"header\"\u003E\u003Cdiv\u003EOrder " + (pug_escape(null == (pug_interp = order.number) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"qrcode-container\"\u003E\u003Cdiv\u003E\u003Ccanvas" + (" class=\"qrcode\""+pug_attr("data-url", toQRCodeUrl(order.qrcode_id), true, true)) + "\u003E\u003C\u002Fcanvas\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"options\"\u003E";
// iterate (lineItem.options || [])
;(function(){
  var $$obj = (lineItem.options || []);
  if ('number' == typeof $$obj.length) {
      for (var pug_index17 = 0, $$l = $$obj.length; pug_index17 < $$l; pug_index17++) {
        var option = $$obj[pug_index17];
if (highlightOption(option)) {
pug_html = pug_html + "\u003Cdiv class=\"option\"\u003E" + (pug_escape(null == (pug_interp = prettyOption(option)) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
      }
  } else {
    var $$l = 0;
    for (var pug_index17 in $$obj) {
      $$l++;
      var option = $$obj[pug_index17];
if (highlightOption(option)) {
pug_html = pug_html + "\u003Cdiv class=\"option\"\u003E" + (pug_escape(null == (pug_interp = prettyOption(option)) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"buyerInfo\"\u003E\u003Cdiv class=\"date\"\u003E" + (pug_escape(null == (pug_interp = labelDate(order.deliveryDate)) ? "" : pug_interp)) + "\n";
if (order.deliveryAfter || order.deliveryBefore) {
pug_html = pug_html + "\u003Cdiv\u003E";
if (order.deliveryAfter) {
pug_html = pug_html + "\u003Cstrong\u003E\nafter " + (pug_escape(null == (pug_interp = order.deliveryAfter) ? "" : pug_interp)) + "\n\u003C\u002Fstrong\u003E";
}
if (order.deliveryBefore) {
pug_html = pug_html + "\u003Cstrong\u003E                                                       |\nbefore " + (pug_escape(null == (pug_interp = order.deliveryBefore) ? "" : pug_interp)) + "\n\u003C\u002Fstrong\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
}
else {
var orderTimeInfo = getOrderTimeInfo(order)
if (orderTimeInfo) {
pug_html = pug_html + "\u003Cdiv\u003E\u003Cstrong\u003E" + (pug_escape(null == (pug_interp = orderTimeInfo) ? "" : pug_interp)) + "\u003C\u002Fstrong\u003E\u003C\u002Fdiv\u003E";
}
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
if (! shipmentDetailsAddress) {
pug_html = pug_html + "\u003Cdiv class=\"name\"\u003E" + (pug_escape(null == (pug_interp = order.buyerInfo.firstName) ? "" : pug_interp)) + " " + (pug_escape(null == (pug_interp = order.buyerInfo.lastName) ? "" : pug_interp)) + "\u003Cbr\u003E" + (pug_escape(null == (pug_interp = order.buyerInfo.phone) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
if (shipmentDetailsAddress) {
pug_html = pug_html + "\u003Cdiv class=\"delivery-address\"\u003E";
pug_mixins["render_address"](shipmentDetailsAddress, order);
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
}
if (isToPay(order)) {
pug_html = pug_html + "\u003Cdiv\u003E\u003Cstrong style=\"margin-top: 1em\"\u003ETO PAY\u003C\u002Fstrong\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
if (! (idx == orders.length - 1 && lidx == order.lineItems.length - 1)) {
pug_html = pug_html + "\u003Cdiv class=\"pagebreak\"\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
}
      }
  } else {
    var $$l = 0;
    for (var lidx in $$obj) {
      $$l++;
      var lineItem = $$obj[lidx];
var shipmentDetailsAddress = order.shippingInfo && order.shippingInfo.shipmentDetails && order.shippingInfo.shipmentDetails.address;
var labelCount = countLabels(lineItem)
for (let i = 0; i < labelCount; i++)
{
pug_html = pug_html + "\u003Cdiv class=\"order-container\"\u003E\u003Cdiv class=\"order\"\u003E\u003Cdiv class=\"header\"\u003E\u003Cdiv\u003EOrder " + (pug_escape(null == (pug_interp = order.number) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"qrcode-container\"\u003E\u003Cdiv\u003E\u003Ccanvas" + (" class=\"qrcode\""+pug_attr("data-url", toQRCodeUrl(order.qrcode_id), true, true)) + "\u003E\u003C\u002Fcanvas\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"options\"\u003E";
// iterate (lineItem.options || [])
;(function(){
  var $$obj = (lineItem.options || []);
  if ('number' == typeof $$obj.length) {
      for (var pug_index18 = 0, $$l = $$obj.length; pug_index18 < $$l; pug_index18++) {
        var option = $$obj[pug_index18];
if (highlightOption(option)) {
pug_html = pug_html + "\u003Cdiv class=\"option\"\u003E" + (pug_escape(null == (pug_interp = prettyOption(option)) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
      }
  } else {
    var $$l = 0;
    for (var pug_index18 in $$obj) {
      $$l++;
      var option = $$obj[pug_index18];
if (highlightOption(option)) {
pug_html = pug_html + "\u003Cdiv class=\"option\"\u003E" + (pug_escape(null == (pug_interp = prettyOption(option)) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"buyerInfo\"\u003E\u003Cdiv class=\"date\"\u003E" + (pug_escape(null == (pug_interp = labelDate(order.deliveryDate)) ? "" : pug_interp)) + "\n";
if (order.deliveryAfter || order.deliveryBefore) {
pug_html = pug_html + "\u003Cdiv\u003E";
if (order.deliveryAfter) {
pug_html = pug_html + "\u003Cstrong\u003E\nafter " + (pug_escape(null == (pug_interp = order.deliveryAfter) ? "" : pug_interp)) + "\n\u003C\u002Fstrong\u003E";
}
if (order.deliveryBefore) {
pug_html = pug_html + "\u003Cstrong\u003E                                                       |\nbefore " + (pug_escape(null == (pug_interp = order.deliveryBefore) ? "" : pug_interp)) + "\n\u003C\u002Fstrong\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
}
else {
var orderTimeInfo = getOrderTimeInfo(order)
if (orderTimeInfo) {
pug_html = pug_html + "\u003Cdiv\u003E\u003Cstrong\u003E" + (pug_escape(null == (pug_interp = orderTimeInfo) ? "" : pug_interp)) + "\u003C\u002Fstrong\u003E\u003C\u002Fdiv\u003E";
}
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
if (! shipmentDetailsAddress) {
pug_html = pug_html + "\u003Cdiv class=\"name\"\u003E" + (pug_escape(null == (pug_interp = order.buyerInfo.firstName) ? "" : pug_interp)) + " " + (pug_escape(null == (pug_interp = order.buyerInfo.lastName) ? "" : pug_interp)) + "\u003Cbr\u003E" + (pug_escape(null == (pug_interp = order.buyerInfo.phone) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
if (shipmentDetailsAddress) {
pug_html = pug_html + "\u003Cdiv class=\"delivery-address\"\u003E";
pug_mixins["render_address"](shipmentDetailsAddress, order);
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
}
if (isToPay(order)) {
pug_html = pug_html + "\u003Cdiv\u003E\u003Cstrong style=\"margin-top: 1em\"\u003ETO PAY\u003C\u002Fstrong\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
if (! (idx == orders.length - 1 && lidx == order.lineItems.length - 1)) {
pug_html = pug_html + "\u003Cdiv class=\"pagebreak\"\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
}
    }
  }
}).call(this);

      }
  } else {
    var $$l = 0;
    for (var idx in $$obj) {
      $$l++;
      var order = $$obj[idx];
// iterate order.lineItems
;(function(){
  var $$obj = order.lineItems;
  if ('number' == typeof $$obj.length) {
      for (var lidx = 0, $$l = $$obj.length; lidx < $$l; lidx++) {
        var lineItem = $$obj[lidx];
var shipmentDetailsAddress = order.shippingInfo && order.shippingInfo.shipmentDetails && order.shippingInfo.shipmentDetails.address;
var labelCount = countLabels(lineItem)
for (let i = 0; i < labelCount; i++)
{
pug_html = pug_html + "\u003Cdiv class=\"order-container\"\u003E\u003Cdiv class=\"order\"\u003E\u003Cdiv class=\"header\"\u003E\u003Cdiv\u003EOrder " + (pug_escape(null == (pug_interp = order.number) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"qrcode-container\"\u003E\u003Cdiv\u003E\u003Ccanvas" + (" class=\"qrcode\""+pug_attr("data-url", toQRCodeUrl(order.qrcode_id), true, true)) + "\u003E\u003C\u002Fcanvas\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"options\"\u003E";
// iterate (lineItem.options || [])
;(function(){
  var $$obj = (lineItem.options || []);
  if ('number' == typeof $$obj.length) {
      for (var pug_index20 = 0, $$l = $$obj.length; pug_index20 < $$l; pug_index20++) {
        var option = $$obj[pug_index20];
if (highlightOption(option)) {
pug_html = pug_html + "\u003Cdiv class=\"option\"\u003E" + (pug_escape(null == (pug_interp = prettyOption(option)) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
      }
  } else {
    var $$l = 0;
    for (var pug_index20 in $$obj) {
      $$l++;
      var option = $$obj[pug_index20];
if (highlightOption(option)) {
pug_html = pug_html + "\u003Cdiv class=\"option\"\u003E" + (pug_escape(null == (pug_interp = prettyOption(option)) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"buyerInfo\"\u003E\u003Cdiv class=\"date\"\u003E" + (pug_escape(null == (pug_interp = labelDate(order.deliveryDate)) ? "" : pug_interp)) + "\n";
if (order.deliveryAfter || order.deliveryBefore) {
pug_html = pug_html + "\u003Cdiv\u003E";
if (order.deliveryAfter) {
pug_html = pug_html + "\u003Cstrong\u003E\nafter " + (pug_escape(null == (pug_interp = order.deliveryAfter) ? "" : pug_interp)) + "\n\u003C\u002Fstrong\u003E";
}
if (order.deliveryBefore) {
pug_html = pug_html + "\u003Cstrong\u003E                                                       |\nbefore " + (pug_escape(null == (pug_interp = order.deliveryBefore) ? "" : pug_interp)) + "\n\u003C\u002Fstrong\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
}
else {
var orderTimeInfo = getOrderTimeInfo(order)
if (orderTimeInfo) {
pug_html = pug_html + "\u003Cdiv\u003E\u003Cstrong\u003E" + (pug_escape(null == (pug_interp = orderTimeInfo) ? "" : pug_interp)) + "\u003C\u002Fstrong\u003E\u003C\u002Fdiv\u003E";
}
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
if (! shipmentDetailsAddress) {
pug_html = pug_html + "\u003Cdiv class=\"name\"\u003E" + (pug_escape(null == (pug_interp = order.buyerInfo.firstName) ? "" : pug_interp)) + " " + (pug_escape(null == (pug_interp = order.buyerInfo.lastName) ? "" : pug_interp)) + "\u003Cbr\u003E" + (pug_escape(null == (pug_interp = order.buyerInfo.phone) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
if (shipmentDetailsAddress) {
pug_html = pug_html + "\u003Cdiv class=\"delivery-address\"\u003E";
pug_mixins["render_address"](shipmentDetailsAddress, order);
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
}
if (isToPay(order)) {
pug_html = pug_html + "\u003Cdiv\u003E\u003Cstrong style=\"margin-top: 1em\"\u003ETO PAY\u003C\u002Fstrong\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
if (! (idx == orders.length - 1 && lidx == order.lineItems.length - 1)) {
pug_html = pug_html + "\u003Cdiv class=\"pagebreak\"\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
}
      }
  } else {
    var $$l = 0;
    for (var lidx in $$obj) {
      $$l++;
      var lineItem = $$obj[lidx];
var shipmentDetailsAddress = order.shippingInfo && order.shippingInfo.shipmentDetails && order.shippingInfo.shipmentDetails.address;
var labelCount = countLabels(lineItem)
for (let i = 0; i < labelCount; i++)
{
pug_html = pug_html + "\u003Cdiv class=\"order-container\"\u003E\u003Cdiv class=\"order\"\u003E\u003Cdiv class=\"header\"\u003E\u003Cdiv\u003EOrder " + (pug_escape(null == (pug_interp = order.number) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"qrcode-container\"\u003E\u003Cdiv\u003E\u003Ccanvas" + (" class=\"qrcode\""+pug_attr("data-url", toQRCodeUrl(order.qrcode_id), true, true)) + "\u003E\u003C\u002Fcanvas\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"options\"\u003E";
// iterate (lineItem.options || [])
;(function(){
  var $$obj = (lineItem.options || []);
  if ('number' == typeof $$obj.length) {
      for (var pug_index21 = 0, $$l = $$obj.length; pug_index21 < $$l; pug_index21++) {
        var option = $$obj[pug_index21];
if (highlightOption(option)) {
pug_html = pug_html + "\u003Cdiv class=\"option\"\u003E" + (pug_escape(null == (pug_interp = prettyOption(option)) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
      }
  } else {
    var $$l = 0;
    for (var pug_index21 in $$obj) {
      $$l++;
      var option = $$obj[pug_index21];
if (highlightOption(option)) {
pug_html = pug_html + "\u003Cdiv class=\"option\"\u003E" + (pug_escape(null == (pug_interp = prettyOption(option)) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"buyerInfo\"\u003E\u003Cdiv class=\"date\"\u003E" + (pug_escape(null == (pug_interp = labelDate(order.deliveryDate)) ? "" : pug_interp)) + "\n";
if (order.deliveryAfter || order.deliveryBefore) {
pug_html = pug_html + "\u003Cdiv\u003E";
if (order.deliveryAfter) {
pug_html = pug_html + "\u003Cstrong\u003E\nafter " + (pug_escape(null == (pug_interp = order.deliveryAfter) ? "" : pug_interp)) + "\n\u003C\u002Fstrong\u003E";
}
if (order.deliveryBefore) {
pug_html = pug_html + "\u003Cstrong\u003E                                                       |\nbefore " + (pug_escape(null == (pug_interp = order.deliveryBefore) ? "" : pug_interp)) + "\n\u003C\u002Fstrong\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
}
else {
var orderTimeInfo = getOrderTimeInfo(order)
if (orderTimeInfo) {
pug_html = pug_html + "\u003Cdiv\u003E\u003Cstrong\u003E" + (pug_escape(null == (pug_interp = orderTimeInfo) ? "" : pug_interp)) + "\u003C\u002Fstrong\u003E\u003C\u002Fdiv\u003E";
}
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
if (! shipmentDetailsAddress) {
pug_html = pug_html + "\u003Cdiv class=\"name\"\u003E" + (pug_escape(null == (pug_interp = order.buyerInfo.firstName) ? "" : pug_interp)) + " " + (pug_escape(null == (pug_interp = order.buyerInfo.lastName) ? "" : pug_interp)) + "\u003Cbr\u003E" + (pug_escape(null == (pug_interp = order.buyerInfo.phone) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
if (shipmentDetailsAddress) {
pug_html = pug_html + "\u003Cdiv class=\"delivery-address\"\u003E";
pug_mixins["render_address"](shipmentDetailsAddress, order);
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
}
if (isToPay(order)) {
pug_html = pug_html + "\u003Cdiv\u003E\u003Cstrong style=\"margin-top: 1em\"\u003ETO PAY\u003C\u002Fstrong\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
if (! (idx == orders.length - 1 && lidx == order.lineItems.length - 1)) {
pug_html = pug_html + "\u003Cdiv class=\"pagebreak\"\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
}
    }
  }
}).call(this);

    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
    }.call(this, "countLabels" in locals_for_with ?
        locals_for_with.countLabels :
        typeof countLabels !== 'undefined' ? countLabels : undefined, "customFieldsSorter" in locals_for_with ?
        locals_for_with.customFieldsSorter :
        typeof customFieldsSorter !== 'undefined' ? customFieldsSorter : undefined, "getDeliveryCost" in locals_for_with ?
        locals_for_with.getDeliveryCost :
        typeof getDeliveryCost !== 'undefined' ? getDeliveryCost : undefined, "getOrderTimeInfo" in locals_for_with ?
        locals_for_with.getOrderTimeInfo :
        typeof getOrderTimeInfo !== 'undefined' ? getOrderTimeInfo : undefined, "highlightOption" in locals_for_with ?
        locals_for_with.highlightOption :
        typeof highlightOption !== 'undefined' ? highlightOption : undefined, "isToPay" in locals_for_with ?
        locals_for_with.isToPay :
        typeof isToPay !== 'undefined' ? isToPay : undefined, "labelDate" in locals_for_with ?
        locals_for_with.labelDate :
        typeof labelDate !== 'undefined' ? labelDate : undefined, "orders" in locals_for_with ?
        locals_for_with.orders :
        typeof orders !== 'undefined' ? orders : undefined, "prettyOption" in locals_for_with ?
        locals_for_with.prettyOption :
        typeof prettyOption !== 'undefined' ? prettyOption : undefined, "print_format" in locals_for_with ?
        locals_for_with.print_format :
        typeof print_format !== 'undefined' ? print_format : undefined, "renderDollars" in locals_for_with ?
        locals_for_with.renderDollars :
        typeof renderDollars !== 'undefined' ? renderDollars : undefined, "renderName" in locals_for_with ?
        locals_for_with.renderName :
        typeof renderName !== 'undefined' ? renderName : undefined, "toQRCodeUrl" in locals_for_with ?
        locals_for_with.toQRCodeUrl :
        typeof toQRCodeUrl !== 'undefined' ? toQRCodeUrl : undefined));
    ;;return pug_html;}